import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Scene3D from "../components/Scene3D";
import { MascotWelcome, MascotTip } from "../components/Mascot";
import { Reveal } from "../lib/motion";
import { useRequestDialog } from "../components/RequestDialog";
import { api } from "../lib/api";
import { usePageMeta } from "../lib/seo";
import { BUSINESS, SERVICES } from "../content/defaults";

const FALLBACK = Object.fromEntries(SERVICES.map((s) => [s.id, s]));

export default function ServicePage() {
  const { slug } = useParams();
  const openDialog = useRequestDialog();
  const [svc, setSvc] = useState(FALLBACK[slug] || SERVICES[0]);

  usePageMeta(`${svc.title} in Hawaiian Gardens | C.C.C. Auto Electric`,
    `${svc.heading} Describe your ${svc.title.toLowerCase()} concern to C.C.C. Auto Electric — ${BUSINESS.phoneDisplay}.`);

  useEffect(() => {
    setSvc(FALLBACK[slug] || SERVICES[0]);
    api(`/content/service_${slug}`).then((d) => {
      setSvc((s) => ({ ...s, heading: d.content.heading, paragraphs: d.content.paragraphs,
        preparation: d.content.preparation, faqs: d.content.faqs.map((f) => ({ q: f.question, a: f.answer })) }));
    }).catch(() => {});
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <main>
      <section className="hero" style={{ paddingBottom: 30 }}>
        <div className="container">
          <MascotWelcome badge={`Service · ${svc.title}`} size={170}
            text="Tell us what your vehicle is doing and I'll help you collect the details for the shop."
            onCta={() => openDialog(svc.primary.service, "", true)} />
        </div>
      </section>

      <section style={{ paddingBottom: 60 }}>
        <div className="container">
          <div className="service-row" data-testid="service-hero-row">
            <Reveal>
              <Scene3D variant={svc.variant} />
            </Reveal>
            <Reveal delay={0.1}>
              <div className="service-copy">
                <span className="eyebrow red">{svc.title.toUpperCase()}</span>
                <h1 style={{ fontSize: "clamp(28px,3.6vw,44px)", lineHeight: 1.08, margin: "12px 0 18px" }} data-testid="service-heading">{svc.heading}</h1>
                {svc.paragraphs.map((p, i) => <p key={i} className="muted" style={{ lineHeight: 1.75 }}>{p}</p>)}
                <div className="row-actions">
                  <button className="btn btn-red" onClick={() => openDialog(svc.primary.service, "", true)} data-testid="service-book-cta">{svc.primary.label}</button>
                  <button className="btn btn-ghost" onClick={() => openDialog(svc.primary.service)} data-testid="service-describe-cta">Describe This Problem</button>
                </div>
                <p className="form-note" style={{ marginTop: 16 }}>{BUSINESS.address} · {BUSINESS.phoneDisplay}</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 20 }}>
        <div className="container" style={{ maxWidth: 820 }}>
          <Reveal>
            <div className="card" style={{ padding: 30 }}>
              <h3 style={{ fontSize: 19, marginBottom: 14 }}>How to prepare for your visit</h3>
              <ul className="symptoms">
                {svc.preparation.map((p, i) => <li key={i}>{p}</li>)}
              </ul>
            </div>
          </Reveal>
          <div style={{ marginTop: 50 }}>
            <span className="eyebrow">Service FAQs</span>
            <h2 style={{ fontSize: "clamp(22px,2.8vw,32px)", margin: "12px 0 22px" }}>Common questions about {svc.title.toLowerCase()}.</h2>
            <div data-testid="service-faq-list">
              {svc.faqs.map((f, i) => (
                <details className="faq" key={i} data-testid={`service-faq-item-${i}`}>
                  <summary>{f.q}<span className="chev">+</span></summary>
                  <p>{f.a}</p>
                </details>
              ))}
            </div>
          </div>
          <div style={{ marginTop: 44 }}>
            <MascotTip />
          </div>
        </div>
      </section>
    </main>
  );
}
